import { GeneralUtils } from '@shared/utils';
import { DataService, FlagService, LoadscreenService } from '@core/services';
import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { LoaderService } from '@core/loader/loader.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent {

  constructor(public generalUtils: GeneralUtils, public FlagService: FlagService, public LoadscreenService: LoadscreenService,
              private translate: TranslateService, private dataService: DataService, private cookie: CookieService,
              public loaderService: LoaderService) {
    this.translate.setDefaultLang(this.dataService.selectedLanguage);
//    const lang = this.cookie.get('language');
//    this.dataService.setLanguage(lang || this.dataService.selectedLanguage);
  }

}
